import { Button, Stack, Typography } from "@mui/material";
import { AnalyzedPlan } from "@labs/shared/types/AnalyzedPlan.ts";
import { OnboardingStepper } from "./OnboardingStepper.tsx";
import { onboardingSteps } from "../data/onboardingSteps.ts";
import { getActiveStepIndex } from "../util/getActiveStepIndex.ts";
import { EmissionsBySource } from "@labs/shared/types/EmissionsBySource.ts";
import { Target } from "@labs/shared/types/Target.ts";
import { Link } from "react-router";
import { trackEvent } from "../util/analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";
import { useLocalUserState } from "../util/useLocalUserState.ts";

type NextStepsBoxProps = {
  target: Target;
  baselineEmissions: EmissionsBySource;
  analyzedPlan: AnalyzedPlan;
};

export const NextStepsBox = ({
  target,
  baselineEmissions,
  analyzedPlan,
}: NextStepsBoxProps) => {
  const [user] = useLocalUserState();
  const activeStepIndex = getActiveStepIndex(
    target,
    baselineEmissions,
    analyzedPlan,
    user.planEmailed,
  );
  const activeStep = onboardingSteps[activeStepIndex];
  return (
    <Stack direction={"column"} spacing={2}>
      <Typography variant={"h6"} color={"primary.dark"}>
        Next Steps
      </Typography>
      <Typography variant="body2">
        Complete these steps to build your plan
      </Typography>
      <OnboardingStepper
        activeStep={activeStepIndex}
        orientation="vertical"
        steps={onboardingSteps}
      />
      {activeStep.href && (
        <Button
          component={Link}
          to={activeStep.href || ""}
          variant="contained"
          color="primary"
          onClick={() =>
            trackEvent(EventCategory.Dashboard, activeStep.buttonText)
          }
        >
          {activeStep.buttonText}
        </Button>
      )}
    </Stack>
  );
};
